"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileTypeFromString = exports.TileTypeEnum = void 0;
var TileTypeEnum;
(function (TileTypeEnum) {
    TileTypeEnum[TileTypeEnum["News"] = 0] = "News";
    TileTypeEnum[TileTypeEnum["Download"] = 1] = "Download";
    TileTypeEnum[TileTypeEnum["Document"] = 2] = "Document";
    TileTypeEnum[TileTypeEnum["CaseStudies"] = 3] = "CaseStudies";
    TileTypeEnum[TileTypeEnum["Events"] = 4] = "Events";
    TileTypeEnum[TileTypeEnum["SearchResults"] = 5] = "SearchResults";
    TileTypeEnum[TileTypeEnum["Product"] = 6] = "Product";
    TileTypeEnum[TileTypeEnum["Course"] = 7] = "Course";
    TileTypeEnum[TileTypeEnum["Products"] = 8] = "Products";
    TileTypeEnum[TileTypeEnum["ProductExternalContent"] = 9] = "ProductExternalContent";
    TileTypeEnum[TileTypeEnum["Drawing"] = 10] = "Drawing";
    TileTypeEnum[TileTypeEnum["Drawings"] = 11] = "Drawings";
    TileTypeEnum[TileTypeEnum["Software"] = 12] = "Software";
    TileTypeEnum[TileTypeEnum["Careers"] = 13] = "Careers";
    TileTypeEnum[TileTypeEnum["OtherContent"] = 14] = "OtherContent";
    TileTypeEnum[TileTypeEnum["Article"] = 15] = "Article";
    TileTypeEnum[TileTypeEnum["SabaCourses"] = 16] = "SabaCourses";
    TileTypeEnum[TileTypeEnum["TileGroupContent"] = 17] = "TileGroupContent";
})(TileTypeEnum || (exports.TileTypeEnum = TileTypeEnum = {}));
exports.TileTypeFromString = {
    ArticlePage: TileTypeEnum.Article,
    Documentation: TileTypeEnum.Document,
    Download: TileTypeEnum.Download,
    DownloadPage: TileTypeEnum.Download,
    Product: TileTypeEnum.Product,
    Products: TileTypeEnum.Product,
    ProductCategory: TileTypeEnum.Product,
    ProductSubCategory: TileTypeEnum.Product,
    ProductExternalContent: TileTypeEnum.ProductExternalContent,
    Drawing: TileTypeEnum.Drawing,
    Drawings: TileTypeEnum.Document,
    Software: TileTypeEnum.Software,
    Careers: TileTypeEnum.Careers,
    Course: TileTypeEnum.Course,
    SabaCourses: TileTypeEnum.SabaCourses,
    OtherContent: TileTypeEnum.OtherContent,
};
